import Collapse from 'react-css-collapse'

import styled, { css } from 'styled-components'
import { padding } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex, Icon } from 'Components/UI/_Legacy'

import plusGlyph from 'Assets/_Legacy/Svg/plus.svg'

export const Container = styled(Flex).attrs({
  flexDirection: 'column',
  py: 4,
})``

export const Header = styled(Flex).attrs({
  width: 1,
  alignItems: 'center',
  px: [5, 5, 7],
})`
  cursor: pointer;
`

export const StyledCollapse = styled(Collapse).attrs({
  className: 'collapse-transition',
})`
  padding: 0 16px;
  transition: all 0.3s;

  ${padding}
`

const plusOpenedCss = ({ opened }) =>
  opened &&
  css`
    fill: ${themeGet('colors.red')};
    transform: rotate(45deg);
  `

export const PlusIcon = styled(Icon).attrs({
  glyph: plusGlyph,
  size: 16,
})`
  fill: ${themeGet('colors.font.primary')};
  transition: transform ${themeGet('transitionTime')}
    cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(0deg);
  margin-top: -2px;

  :hover {
    fill: ${themeGet('colors.red')};
  }

  ${plusOpenedCss};
`
